import type { TFunction } from "i18next";

// Occupation names come from the API (occupations table) in English; the
// list shows them in the interface language. The stored value and the id
// sent back are unchanged. Unknown names are shown as they come.
const KEYS = {
  "family physicians": "familyPhysicians",
  "medical specialist": "medicalSpecialist",
  "surgical specialist": "surgicalSpecialist",
  "nurse practitioner": "nursePractitioner",
  "paramedical practitioners": "paramedicalPractitioners",
  other: "other",
} as const;

export const occupationLabel = (name: string, t: TFunction): string => {
  const key = KEYS[name.trim().toLowerCase() as keyof typeof KEYS];
  return key ? t(`occupations.${key}`) : name;
};
